const api = {
    login: {
        login: 'v1/altair-user-console/user/login',
        loginOut: 'v1/altair-user-console/user/loginout',
        // g7sLogin: 'v1/altair-user-console/user/ucenter_login'
        getUserData: 'v1/altair-user-console/user/ucenter_login/v2',
        exchangeToken: 'v1/openapi-web/login/exchange'
    },
    findBackPwd: {
        hasUserName: 'v1/altair-user-console/user/check_email',
        isPhoneRegist: 'v1/altair-user-console/user/check_phone',
        isEmailRegist: 'v1/altair-user-console/user/check_email',
        sendForgetePhoneValidateCode: 'v1/altair-user-console/user/validate/forget_sms_validate',
        sendForgeteEmailValidateCode: 'v1/altair-user-console/user/validate/forget_email_validate',
        changePassword: 'v1/altair-user-console/user/change_password_new',
        checkValidateCode: 'v1/altair-user-console/user/validate/check_validate',
        resetPassword: 'v1/altair-user-console/user/set_password'
    },
    user: {
        // checkUser: '/zuul/user/check_user',
        checkUser: 'v1/openapi-web/user/check_user',
        modifyPhone: 'v1/altair-user-console/user/change_phone',
        modifyEmail: 'v1/altair-user-console/user/change_email',
        register: 'v1/altair-user-console/user/register',
        getUserInfo: 'v1/altair-user-console/user/get_user',
        sendEmailValidateCode: 'v1/altair-user-console/user/validate/email_validate',
        sendPhoneValidateCode: 'v1/altair-user-console/user/validate/sms_validate',
        supplementInfo: 'v1/altair-user-console/user/perfect_info',
        fetchApplyInfo: 'v1/altair-user-console/user/get_user_apply_info',

    },
    console: {
        getMqttTableData: 'v1/altair-user-console/user/mqtt_push/list',
        getHttpTableData: 'v1/altair-user-console/user/http_push/list'
    },
    sandbox: {
        login: 'v1/altair-user-console/user/login',
        getMqttTableData: 'v1/altair-user-console/user/mqtt_push/mock/list',
        getHttpTableData: 'v1/altair-user-console/user/http_push/mock/list',
        mqttApply: 'v1/altair-user-console/user/mqtt_push/mock/apply',
        httpApply: 'v1/altair-user-console/user/http_push/mock/apply',
        getApiList: 'v1/altair-user-console/user/module/mock/list',
        apiApply: 'v1/altair-user-console/user/module/mock/apply'
    },
    feedback: {
        save: 'v1/openapi-web/feedback'
    },
    scene: {
        save: 'v1/altair-user-console/scene/save'
    }

};

export default api;



// WEBPACK FOOTER //
// ./src/configs/api.js